export function autobind(_: any, _2: any, descriptor: any) {
    const originalMethod = descriptor.value;
    return {
        configurable: true,
        get: function () {
            return originalMethod.bind(this);
        }
    };
}
